<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create User'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <input-text
            name="name"
            label="* Name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
        />
        <input-text
            name="email"
            label="* Email"
            v-model="form.email"
            class="mt-2"
            :error="errors.email ? errors.email[0] : null"
        />
        <input-text
            type="password"
            name="password"
            label="* Password"
            v-model="form.password"
            class="mt-2"
            :error="errors.password ? errors.password[0] : null"
        />
        <div
            class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 dark:text-gray-200 mb-4">Selected Cluster</p>
            <reference
                create-text="Create new cluster and link cluster to this page"
                link-text="Link an existing cluster"
                v-model="form.selectedCluster"
                model-data="Cluster"
                field-name="selected_cluster_id"
            />
        </div>

        <div
            class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 dark:text-gray-200 mb-4">Languages</p>
            <multi-reference
                create-text="Create new language and link language to this page"
                link-text="Link existing languages"
                v-model="form.languages"
                model-data="Site Language"
                :creatable="false"
                :order="{
                    'name': 'asc'
                }"
            />
        </div>

        <div
            class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 dark:text-gray-200 mb-4">Default Language</p>
            <reference
                create-text="Create new language and link language to this page"
                link-text="Link an existing language"
                v-model="form.defaultLanguage"
                model-data="Site Language"
                field-name="default_language_id"
                :order="{
                    'name': 'asc'
                }"
            />
        </div>

        <div
            class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 dark:text-gray-200 mb-4">Roles</p>
            <multi-reference
                create-text="Create new role and link role to this page"
                link-text="Link existing roles"
                v-model="form.roles"
                field-name="roles"
                model-data="Role"
                :with-docs="['rights']"
                :order="{
                    'name': 'asc'
                }"
            />
        </div>

        <div
            class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 dark:text-gray-200 mb-4">Rights from roles</p>
            <div class="flex items-center flex-wrap">
                <badge v-for="right in currentRightNames" :key="right" :value="right" type="success"></badge>
            </div>
        </div>

        <div
            class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 dark:text-gray-200 mb-4">Extra Rights</p>
            <multi-reference
                create-text="Create new extra right and link extra right to this page"
                link-text="Link existing extra rights"
                v-model="form.rights"
                :excluded-ids="currentRightIds"
                field-name="rights"
                model-data="Right"
                :order="{
                    'name': 'asc'
                }"
            />
        </div>

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
export default {
    name: "UserFormNew",
    mixins: [crudForm],
    props: ["clusters"],
    data() {
        return {
            form: {
                name: this.getFormData("name"),
                email: this.getFormData("email"),
                password: "",
                selectedCluster: this.getFormData("selected_cluster"),
                selected_cluster_id: this.getFormData("selected_cluster_id"),
                default_language_id: this.getFormData("default_language_id"),
                defaultLanguage: this.getFormData("default_language"),
                roles: this.getReferenceData("roles"),
                languages: this.getReferenceData("languages"),
                rights: this.getReferenceData("rights"),
            },
        };
    },
    computed: {
        currentRightIds () {
            return [...new Set((this.form.roles || []).map(role => role.rights.map(right => right.id)).flat())];
        },
        currentRightNames () {
            return [...new Set((this.form.roles || []).map(role => role.rights.map(right => right.name)).flat())];
        },
    },
    watch: {
        "form.defaultLanguage": function(newValue){
            this.form.default_language_id = newValue ? newValue.id : null
        },
        "form.selectedCluster": function(newValue){
            this.form.selected_cluster_id = newValue ? newValue.id : null
        }
    }
};
</script>
